import { NavLink } from "react-router-dom";
import * as S from "./styles";
import { useMenu } from "./useMenu";
import { DetailsItemsMenu } from "../../Atoms/DetailsItemsMenu";

export const Menu = () => {
  const { isOpen, setIsOpen, firstName, handleLogout, usuario, isAdmin } =
    useMenu();

  return (
    <S.MenuWrapper data-open={isOpen}>
      <S.MenuHeader data-open={isOpen}>
        <S.WrapperProfile data-open={isOpen}>
          <img src="/assets/svg/profile.svg" alt="icone profile" />
          <S.WrapperProfileText>
            <p>
              Olá, <span>{firstName}</span>
            </p>
            <button onClick={handleLogout}>
              logout <img src="/assets/svg/icon-exit.svg" alt="icon exit" />
            </button>
          </S.WrapperProfileText>
        </S.WrapperProfile>

        <img
          src="/assets/svg/icon-menu.svg"
          alt="icon menu"
          onClick={() => setIsOpen((prev) => !prev)}
        />
      </S.MenuHeader>

      <S.MenuItems>
        <S.MenuItem>
          <NavLink to={"/relatorio-geral"}>
            <img src="/assets/svg/icon-menu1.svg" alt="icone grafico" />
            Produção Geral
          </NavLink>
        </S.MenuItem>
        <DetailsItemsMenu
          titleHeader="Tendência"
          icon="/assets/svg/icon-menu2.svg"
        >
          <NavLink to={"/relatorio-tendencia/starcheck"}>Starcheck</NavLink>
          <NavLink to={"/relatorio-tendencia/log"}>Log Vistorias</NavLink>
          <NavLink to={"/relatorio-tendencia/tokyo"}>Tokyo Vistorias</NavLink>
          <NavLink to={"/relatorio-tendencia/velox"}>VLX Vistorias</NavLink>
        </DetailsItemsMenu>
        <S.MenuItem>
          <NavLink to={"/relatorio-reembolso"}>
            <img src="/assets/svg/icon-menu3.svg" alt="icone grafico" />
            Reembolsos
          </NavLink>
        </S.MenuItem>
        <S.MenuItem>
          <NavLink to={"/relatorio-analitico-reembolso"}>
            <img src="/assets/svg/icon-menu4.svg" alt="icone reembolso" />
            Reembolso - Analítico
          </NavLink>
        </S.MenuItem>
        <S.MenuItem>
          <NavLink to={"/relatorio-colchao"}>
            <img src="/assets/svg/icon-menu5.svg" alt="icone grafico" />
            Colchão de Agendamentos
          </NavLink>
        </S.MenuItem>
        <S.MenuItem>
          <NavLink to={"/relatorio-produtividade-vistoriador"}>
            <img src="/assets/svg/icon-menu6.svg" alt="icone grafico" />
            Produtividade por Vistoriador
          </NavLink>
        </S.MenuItem>
        <S.MenuItem>
          <NavLink to={"/relatorio-produtividade-servico"}>
            <img src="/assets/svg/icon-menu7.svg" alt="icone engrenagem" />
            Produção por Tipo de Serviço
          </NavLink>
        </S.MenuItem>
        <S.MenuItem>
          <NavLink to={"/satisfacao-cliente"}>
            <img src="/assets/svg/icon-star-outline.svg" alt="icone estrela" />
            Satisfação do Cliente
          </NavLink>
        </S.MenuItem>
        <S.MenuItem>
          <NavLink to={"/relatorio-producao-financeira"}>
            <img
              src="/assets/svg/icon-graph-finance.svg"
              alt="icone financeiro"
            />
            Produção Financeira
          </NavLink>
        </S.MenuItem>

        <DetailsItemsMenu
          titleHeader="Conciliação Bancária"
          icon="/assets/svg/icon-menu2.svg"
        >
          <NavLink to={"/relatorio-conciliacao-bancaria/starcheck"}>
            Starcheck
          </NavLink>
          <NavLink to={"/relatorio-conciliacao-bancaria/log"}>
            Log Vistorias
          </NavLink>
          <NavLink to={"/relatorio-conciliacao-bancaria/tokyo"}>
            Tokyo Vistorias
          </NavLink>
          <NavLink to={"/relatorio-conciliacao-bancaria/velox"}>
            VLX Vistorias
          </NavLink>
        </DetailsItemsMenu>
        <S.MenuItem>
          <NavLink to={"/relatorio-produtividade-tipo-cliente"}>
            <img src="/assets/svg/icon-people.svg" alt="icone grafico" />
            Produtividade por tipo de cliente
          </NavLink>
        </S.MenuItem>
        {(isAdmin || usuario?.recursos?.includes("DENUNCIAS")) && (
          <S.MenuItem>
            <NavLink to={"/denuncias"}>
              <img src="/assets/svg/icon-alarm.svg" alt="icone financeiro" />
              Denuncias de Abuso
            </NavLink>
          </S.MenuItem>
        )}
      </S.MenuItems>
    </S.MenuWrapper>
  );
};
